import React from "react";
import ReactTooltip from "react-tooltip";
import ImageSelectorGroup from "./ImageSelector";

function FrameSelector(props) {
  const attrs = {
    id: `frame-selector_${props.panelId}_${props.frameListid}_${props.frame.id}`,
    onClick: props.frame.update,
    className: "frame-selector selector btn"
  };

  attrs.className += props.frame.isCurrent ? " btn-success" : " btn-default";
  if (props.frame.isActive) {
    attrs.className += " selected active";
  }

  const imageSelector =
    props.image && props.image.selector ? (
      <ImageSelectorGroup
        panelId={props.panelId}
        frameId={props.frame.id}
        frameListId={props.frameListId}
        image={props.image}
      />
    ) : (
      ""
    );

  return (
    <div {...attrs} data-tip data-for={`${props.frame.id}_tooltip`}>
      <ReactTooltip
        id={`${props.frame.id}_tooltip`}
        place="bottom"
        effect="solid"
      >
        {props.frame.label}
      </ReactTooltip>
      {props.frame.label}
      {imageSelector}
    </div>
  );
}

function FrameSelectorGroup(props) {
  return (
    <div className="selector-group">
      {props.frame.list.map(frame => (
        <FrameSelector
          key={frame.id}
          panelId={props.panelId}
          frameListId={props.frameListId}
          frame={{
            id: frame.id,
            label: window
              .moment(frame.startValidity || frame.sv)
              .format("DD HHmm"),
            isActive: props.frame.active.id === frame.id,
            isCurrent: props.frame.current.id === frame.id,
            update: frame.setFrame
          }}
          image={{
            list: frame.images,
            currentId: frame.currentImageId,
            activeId: frame.activeImageId,
            selector:
              props.image.selector === undefined ? true : props.image.selector
          }}
        />
      ))}
    </div>
  );
}

export default FrameSelectorGroup;
